// lib
import { useState, useRef, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

import ADND from '@aytm/lib/adnd/ADND'

// components

// styles
import style from '@aytm/app/stats/page/sidebar/components/questions/styles/CustomQuestion.module.scss'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

const PinnedCustomQuestion = ({ item, disabled, addQuestion, removePinnedQuestion, onDNDStart, onDNDEnd }) => {
  const [blocked, setBlocked] = useState(false)

  const timer = useRef(null)

  const dndListItemRef = useRef()

  const createCustomQuestion = useCallback(() => Object.assign({}, item.data), [item])

  const onClick = useCallback(() => {
    setBlocked(true)

    const question = createCustomQuestion()
    addQuestion(null, question)

    timer.current && clearTimeout(timer.current)
    timer.current = setTimeout(() => setBlocked(false), 1000)

    return () => timer.current && clearTimeout(timer.current)
  }, [addQuestion, createCustomQuestion])

  const dndListItem = disabled
    ? null
    : ADND.sources
        .data({
          type: 'pinned-question-custom',
          clearDragImage: false
        })
        .onStart(onDNDStart)
        .onEnd(onDNDEnd)
        .fetchData(createCustomQuestion)

  useEffect(() => {
    if (dndListItem) dndListItem.connect(dndListItemRef.current)

    return () => {
      if (dndListItem) dndListItem.disconnect()
    }
  }, [dndListItem])

  return (
    <div className={style.row}>
      {!disabled && 'function' == typeof removePinnedQuestion ? (
        <span
          className={style.delete}
          aria-label="Remove pinned question"
          {...pressable(() => removePinnedQuestion(item.index))}
        >
          <i className="icon-aytmfd-x-v2" />
        </span>
      ) : null}
      <div ref={dndListItemRef} className={style.button} {...pressable(blocked || disabled ? null : onClick)}>
        <span className={style['button-text']}>
          {item.icon ? <i className={`icon-aytmfd-${item.icon}`} /> : null}
          <span dangerouslySetInnerHTML={{ __html: item.text }}></span>
        </span>
        {disabled ? null : (
          <span className={style['button-handle']}>
            <i className="icon-aytmfd-handle" />
          </span>
        )}
      </div>
    </div>
  )
}

PinnedCustomQuestion.propTypes = {
  item: PropTypes.object,
  disabled: PropTypes.bool,
  addQuestion: PropTypes.func,
  removePinnedQuestion: PropTypes.func,
  onDNDStart: PropTypes.func,
  onDNDEnd: PropTypes.func
}

PinnedCustomQuestion.displayName = 'PinnedCustomQuestion'

export default PinnedCustomQuestion
